import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FieldVS } from 'shared/utils/validation/AuthValidation';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { AddColorsMutation, UpdateColorsMutation } from 'shared/services/color_services/ColorsServices';
import { toastMessage } from 'shared/components/toast/Toast';

export default function AddColors({ show, datatable, handleClose, isEdit = false, editData = null, onSuccessAdd }) {
    const { mutate: addColorsMutation, isLoading: BrandLoading, isSuccess: BrandIsSuccess } = AddColorsMutation();
    const { mutate: updateColorsMutation, isLoading: UpdateColorLoading, isSuccess: UpdateColorIsSuccess } = UpdateColorsMutation();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const initialValues = {
        field: isEdit && editData?.color ? editData.color : ''
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: FieldVS,
        onSubmit: (value) => {
            brandHandler(value);
        }
    });
    const { handleChange, handleSubmit, values, touched, errors } = formik;

    const brandHandler = (values) => {
        const isDuplicate = datatable?.some(
            (color) =>
                color._id !== editData?._id &&
                color.color.trim().toLowerCase() === values.field.trim().toLowerCase()
        );

        if (isDuplicate) {
            toastMessage('error', `Color "${values.field}" already exists!`);
            return;
        }

        if (isEdit && editData?._id) {
            updateColorsMutation({ id: editData._id, payload: { color: values.field } });
        } else {
            addColorsMutation({ color: values.field });
        }
    };

    useEffect(() => {
        if ((BrandIsSuccess || UpdateColorIsSuccess) && show) {
            if (onSuccessAdd) onSuccessAdd(values.field);
            setTimeout(() => {
                formik.resetForm();
                handleClose();
            }, 100);
        }
    }, [BrandIsSuccess, UpdateColorIsSuccess]);

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={isEdit ? 'Edit Color' : 'Add Color'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomInput
                        label={isEdit ? 'Edit Color Name' : 'Add Color'}
                        placeholder={'e.g. Red'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values.field}
                        onChange={handleChange('field')}
                        error={errors.field && touched.field ? errors.field : ''}
                    />

                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={isEdit ? 'Update' : 'Add'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
                {(BrandLoading || UpdateColorLoading) && <OverlayLoading />}
            </Modal.Body>
        </Modal>
    );
}
